
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  computed: {
    teams () {
      return [
        this.getTeam(this.fixture),
        this.getTeam(this.fixture, `Away`),
      ];
    },
  },
};
